import React from 'react';

import { ModalError } from 'common/components/ModalError';
import { ModalLoader } from 'common/components/ModalLoader';
import { useTranslation } from 'common/hooks/useTranslation';
import { useCompanyId } from 'modules/app/hooks/useCompanyId';
import { useUser } from 'modules/app/hooks/useUser';
import { useGetUserAuthenticationFactors } from 'modules/authentication-factor/hooks/useGetUserAuthenticationFactors';
import { type RecoveryShareMethod } from 'modules/members/components/ConfirmRequesterIdentityModal/ConfirmRequesterIdentityModal';
import { RecoveryFactorScaModal } from 'modules/members/components/RecoveryFactorScaModal/RecoveryFactorScaModal';
import { QuerySuspenseBase } from 'src/core/common/components/QuerySuspenseBase/QuerySuspenseBase';

type Props = {
  member: { id: string; email: string };
  onClose: () => void;
  recoveryShareMethod: RecoveryShareMethod;
};

export const RecoveryFactorScaModalContainer = ({
  member,
  onClose,
  recoveryShareMethod,
}: Props) => {
  const { t } = useTranslation('global');
  const companyId = useCompanyId();
  const user = useUser();
  const getUserAuthenticationFactorsQueryState =
    useGetUserAuthenticationFactors({
      userId: user.id,
      companyId,
    });

  return (
    <QuerySuspenseBase
      fallback={() => (
        <ModalError
          message={t('members.errorModal.fetchFailedMessage')}
          onClose={onClose}
        />
      )}
      loading={<ModalLoader />}
      queryState={getUserAuthenticationFactorsQueryState}
    >
      {({ factors }) => (
        <RecoveryFactorScaModal
          factors={factors}
          member={member}
          onCancel={onClose}
          recoveryShareMethod={recoveryShareMethod}
        />
      )}
    </QuerySuspenseBase>
  );
};
